export const environment = {
  production: true,
  sidekiqUrl: `${location.origin}/api/sidekiq`,
  samlConfigSubdomain: null,
  samlConfigEntityId: null
};
